import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define Auth State
type AuthState = {
  token: string | null;
  timeout: string | null;
};

// Initial State
const initialState: AuthState = {
  token: null,
  timeout: null,
};

// Create Slice
export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (
      state,
      action: PayloadAction<{ token: string; timeout: string }>
    ) => {
      state.token = action.payload.token;
    },
    logout: (state) => {
      state.token = null;
      state.timeout = null;
    },
  },
});

// Export Actions
export const { login, logout } = authSlice.actions;

// Export Reducer
export default authSlice.reducer;
